import React, {Component} from 'react';

import { Tree } from 'antd';

const { TreeNode } = Tree;


import services from './../../services';

import Modal from './../Modal';

import Submit from './../Submit';

export default class extends Component{
    constructor(props) {
        super(props);

        this.state = {
            keywords: {},
            treeData: [],
            checkedKeys: []
        }
    }

    componentDidMount() {

        
    }

    componentWillReceiveProps(nextProps) {
        const roleId = nextProps.roleId;
        if(roleId) {
            services.roles.queryRoleTree(roleId)
            .then(response => {
                this.setState({
                    treeData: response.treeData,
                    checkedKeys: response.checkedKeys,
                    expandedKeys:['3']
                });
            });
        }
        
    }


    onExpand(expandedKeys) {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onCheck(checkedKeys) {
        this.setState({ checkedKeys })
    }

    onSelect(selectedKeys) {
        this.setState({ selectedKeys });
    }

    renderTreeNodes(data) {
        return data.map((item) => {
            if (item.children) {
              return (
                <TreeNode title={item.title} key={item.key} dataRef={item}>
                  {this.renderTreeNodes(item.children)}
                </TreeNode>
              );
            }
            return <TreeNode {...item} />;
        });
    }
    
    handleSubmit() {
        const data = {
            roleId: this.props.roleId,
            moduleIds: this.state.checkedKeys
        };


        services.roles.saveRoleTree(data).then(d => {
            this.handleCancel();
        });
        
    }

    handleCancel() {
        this.props.handleCancel();
        this.setState({
            keywords: {random: Math.random(), visible: this.props.visible},
        })
    }
    

    render() {
        const { treeData } = this.state;
        return (
            <Modal title="系统功能信息" width={500} visible={this.props.visible}  handleSubmit={this.handleSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
            <div className="root-role-tree">
            <Tree
                checkable
                onExpand={this.onExpand.bind(this)}
                expandedKeys={this.state.expandedKeys}
                autoExpandParent={this.state.autoExpandParent}
                onCheck={this.onCheck.bind(this)}
                checkedKeys={this.state.checkedKeys}
                onSelect={this.onSelect.bind(this)}
                selectedKeys={this.state.selectedKeys}
            >
                {this.renderTreeNodes(treeData)}
            </Tree>
            </div>
            </Modal>
            
        );
    }
}